import Alert from '@mui/material/Alert';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { useTranslation } from 'react-i18next';
import { getDealsLabels } from '../../../../../lib/DealForm/utils/dealFormUtils.ts';
import type { UseBrandsOptionsFetch } from '../../../../../lib/utils/context/DealHookTypes.ts';

export interface BrandRenderProps {
  useBrandFetch: UseBrandsOptionsFetch;
  brandSalesforceId: string | null | undefined;
}

export const BrandRender = ({ useBrandFetch, brandSalesforceId }: BrandRenderProps) => {
  const { t } = useTranslation();
  const labels = getDealsLabels(t);
  const { mapById: brandMap, loading: isLoading } = useBrandFetch();

  const brandName = brandSalesforceId ? (brandMap[brandSalesforceId]?.name ?? brandSalesforceId) : null;

  const showWarning = !isLoading && brandSalesforceId && brandMap[brandSalesforceId] === undefined;

  return (
    <>
      {showWarning && (
        <Alert severity="warning" sx={{ marginBottom: 1.5 }} data-test="brand-not-found">
          {t('The brand has been removed from Salesforce')}
        </Alert>
      )}

      <FieldDetails loading={isLoading} title={labels.brand_salesforce_id} value={brandName} />
    </>
  );
};
